import React from "react";

const GatewayForm = ({
  formData,
  lookups,
  errors,
  loading,
  editId,
  handleChange,
  handleSubmit,
  onClose
}) => {
  return (
    <div className="payment-gateway-body">
      <form onSubmit={handleSubmit}>
        <div className="gateway-form-header">
          <h5 className="text-white mb-0">Payment Gateway Details</h5>
          <button type="button" className="gateway-close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="mb-3">
          <label className="payment-gateway-label">Payment Gateway Provider</label>
          <select 
            className="form-select payment-gateway-select" 
            name="provider" 
            value={formData.provider} 
            onChange={handleChange}
          >
            {lookups.providers.map((item, index) => (
              <option key={index} value={item.key}>{item.value}</option>
            ))}
          </select>
        </div>
        {formData.provider !== "dummy" && (
          <>
            <div className="mb-4">
              <label className="form-label fw-bold">Payment Mode</label>
              <select
                className="form-select payment-gateway-select"
                name="active_mode"
                value={formData.active_mode}
                onChange={handleChange}
              >
                {lookups.modes.map((item, index) => (
                  <option key={index} value={item.key}>
                    {item.value}
                  </option>
                ))}
              </select>
            </div>

            <div className="gateway-credential-card">
              <div
                className={
                  formData.active_mode === "demo"
                    ? "gateway-demo-header"
                    : "gateway-live-header"
                }
              >
                {formData.active_mode === "demo" ? "Demo" : "Live"} Credentials
              </div>

              <div className="gateway-credential-body">
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    {formData.active_mode === "demo" ? "Demo" : "Live"} API Key
                  </label>
                  <input
                    type="text"
                    className="form-control payment-gateway-input"
                    name={
                      formData.active_mode === "demo"
                        ? "demo_api_key"
                        : "live_api_key"
                    }
                    value={
                      formData.active_mode === "demo"
                        ? formData.demo_api_key
                        : formData.live_api_key
                    }
                    onChange={handleChange}
                  />
                  {errors.apiKey && (
                    <div className="text-danger small">
                      {errors.apiKey}
                    </div>
                  )}
                </div>

                <div>
                  <label className="form-label fw-semibold">
                    {formData.active_mode === "demo" ? "Demo" : "Live"} Secret Key
                  </label>
                  <input
                    type="text"
                    className="form-control payment-gateway-input"
                    name={
                      formData.active_mode === "demo"
                        ? "demo_secret_key"
                        : "live_secret_key"
                    }
                    value={
                      formData.active_mode === "demo"
                        ? formData.demo_secret_key
                        : formData.live_secret_key
                    }
                    onChange={handleChange}
                  />
                  {errors.secretKey && (
                    <div className="text-danger small">
                      {errors.secretKey}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </>
        )}
        <button type="submit" className="payment-gateway-save-btn" disabled={loading}>
          {loading ? (editId ? "Updating..." : "Saving...") : (editId ? "Update Configuration" : "Save Configuration")}
        </button>
      </form>
    </div>
  );
};

export default GatewayForm;
